export default {
  title: 'Úložiště souborů',
  Header: {
    title: 'Úložiště souborů',
    upload: 'Nahrát nové soubory',
  },
  Content: {
    emptyText: 'Zatím nebyly nahrány žádné soubory',
  },
  Filter: {
    all: 'Vše',
  },
  MyUnit: {
    title: 'Soubory pro vaši jednotku',
    unit: 'Jednotka č. {{label}}',
  },
  Shared: {
    title: 'Společné soubory domu',
  },
  Category: {
    // pro jednotku
    billing: 'Vyúčtování',
    advance_payment: 'Předpis záloh',
    meter_reading: 'Odečty měřidel',
    unit_inspection: 'Revize a kontroly v bytě',
    contract: 'Smlouvy',
    correspondence: 'Korespondence',
    handover_protocol: 'Předávací protokoly',
    // pro celý dům
    assembly_minutes: 'Zápisy ze shromáždění',
    founding_documents: 'Stanovy a založení',
    accounting: 'Účetnictví',
    supplier_contract: 'Smlouvy s dodavateli',
    building_inspection: 'Revize a technická dokumentace',
    insurance: 'Pojištění',
    house_rules: 'Domovní řád a směrnice',
    // společné
    other: 'Ostatní',
  },
  ModalUpload: {
    title: 'Nahrát nové soubory',
    subtitle: 'Na úložiště souborů můžete nahrát pouze obrázky a dokumenty.',
    submit: 'Nahrát',
    formError: 'Soubory se nepodařilo nahrát, zkuste to prosím znovu.',
    Flash: {
      success: 'Soubory byly úspěšně nahrány.',
      successUnit: 'Soubory byly úspěšně nahrány k jednotce č. {{unit}}. Najdete je v detailu jednotky.',
    },

    Attachment: {
      label: 'Vybrat soubory',
      filesLabel: 'Pro dokončení nahrávání klikněte na tlačítko níže.',
    },
    Scope: {
      label: 'Komu jsou soubory určeny',
      building: 'Celému domu',
      building_description: 'Soubory uvidí všichni členové v úložišti souborů.',
      unit: 'Konkrétní jednotce',
      unit_description:
        'Soubory se uloží k jednotce (např. vyúčtování). Uvidí je jen vlastníci dané jednotky, kterým zároveň odejde e-mailové upozornění.',
    },
    Unit: {
      label: 'Jednotka',
      placeholder: 'Vyhledejte dle čísla jednotky nebo příjmení vlastníka',
      required: 'Vyberte jednotku, které chcete soubory uložit.',
    },
    Category: {
      label: 'Kategorie souborů',
    },
  },
  ModalRename: {
    title: 'Přejmenovat soubor',
    submit: 'Přejmenovat',
    Form: {
      Fields: {
        Filename: {
          label: 'Název souboru',
          placeholder: 'Zadejte nový souboru',
          required: 'Název souboru je povinný',
          max: 'Název souboru může mít maximálně {{count}} znaků.',
        },
        Submit: {
          title: 'Přejmenovat soubor',
        },
      },
    },
    Flash: {
      success: 'Soubor byl úspěšně přejmenován',
      error: 'Soubor se nepodařilo přejmenovat, zkuste to prosím znovu.',
    },
  },
  ModalDelete: {
    title: 'Opravdu chcete soubor smazat?',
    submit: 'Ano, smazat',
    Flash: {
      success: 'Soubor byl úspěšně smazán',
      error: 'Soubor se nepodařilo smazat, zkuste to prosím znovu.',
    },
  },
};
